export default __webpack_public_path__ + "static/media/mempools_bl.d6fe8483.png";